(function () {
  'use strict';

  if (!window.Motion) return;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var EASE = [0.16, 1, 0.3, 1]; /* matches the theme's --transition-slow curve */
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function shouldAnimate() {
    return !prefersReducedMotion && !!window.Motion;
  }

  function revealInstantly(els) {
    els.forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  if (shouldAnimate()) {
    document.documentElement.classList.add('motion-buttons-ready');
  }

  /* ---------- Hero entrance (main visual + headings) ---------- */

  var heroRegistry = new WeakSet();

  function initHeroEntrance(section) {
    if (heroRegistry.has(section)) return;
    heroRegistry.add(section);

    var media = qs('[data-hero-media-animate]', section);
    var textEls = qsa('[data-hero-animate]', section);

    if (!shouldAnimate()) {
      if (media) revealInstantly([media]);
      revealInstantly(textEls);
      return;
    }

    if (media) {
      Motion.animate(media, { opacity: [0, 1], scale: [1.06, 1] }, { duration: 1.2, easing: EASE });
    }
    if (textEls.length) {
      Motion.animate(textEls, { opacity: [0, 1], y: [24, 0] }, {
        duration: 0.7,
        delay: Motion.stagger(0.1),
        easing: EASE
      });
    }
  }

  /* ---------- Product card grid: staggered reveal on scroll ---------- */

  var gridRegistry = new WeakSet();
  var gridObservers = new WeakMap();

  function initGridReveal(grid) {
    if (gridRegistry.has(grid)) return;
    gridRegistry.add(grid);

    var cards = qsa('.product-card', grid);
    if (!cards.length) return;

    /* Tell theme.js's generic [data-animate] reveal to skip this grid so it isn't animated twice */
    window.ShorreFindsGridMotionOwned = true;

    if (!shouldAnimate() || !('IntersectionObserver' in window)) {
      revealInstantly(cards);
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        var index = cards.indexOf(entry.target);
        Motion.animate(entry.target, { opacity: [0, 1], y: [24, 0] }, {
          duration: 0.5,
          delay: Math.min(index, 7) * 0.08, /* cap stagger past 8 cards so a long grid doesn't feel sluggish */
          easing: EASE
        });
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    cards.forEach(function (card) { observer.observe(card); });
    gridObservers.set(grid, observer);
  }

  function teardownGridReveal(grid) {
    gridRegistry.delete(grid);
    var observer = gridObservers.get(grid);
    if (observer) {
      observer.disconnect();
      gridObservers.delete(grid);
    }
  }

  /* ---------- Elegant hover / press feedback for buttons + product images ---------- */

  var HOVER_SELECTOR = '.btn, .product-card__media';

  function animateScale(el, scale, duration) {
    if (!shouldAnimate()) return;
    Motion.animate(el, { scale: scale }, { duration: duration || 0.3, easing: EASE });
  }

  /* .product-card__media clips via overflow:hidden; scale its <img>s (as the old CSS
     rule did), not the container itself, so the zoom stays clipped to the card media. */
  function hoverTargetFor(el) {
    return el.classList.contains('product-card__media') ? qsa('img', el) : el;
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch' || !e.target.closest) return;
    var target = e.target.closest(HOVER_SELECTOR);
    if (!target || (e.relatedTarget && target.contains(e.relatedTarget))) return;
    animateScale(hoverTargetFor(target), 1.03);
  });

  document.addEventListener('pointerout', function (e) {
    if (e.pointerType === 'touch' || !e.target.closest) return;
    var target = e.target.closest(HOVER_SELECTOR);
    if (!target || (e.relatedTarget && target.contains(e.relatedTarget))) return;
    animateScale(hoverTargetFor(target), 1);
  });

  document.addEventListener('pointerdown', function (e) {
    if (!e.target.closest) return;
    var target = e.target.closest('.btn');
    if (!target) return;
    animateScale(target, 0.97, 0.15);
  });

  document.addEventListener('pointerup', function (e) {
    if (!e.target.closest) return;
    var target = e.target.closest('.btn');
    if (!target) return;
    animateScale(target, e.pointerType === 'touch' ? 1 : 1.03, 0.2);
  });

  /* ---------- Lifecycle (incl. Shopify theme editor section reloads) ---------- */

  function init() {
    qsa('[data-story-section]').forEach(initHeroEntrance);
    qsa('[data-motion-grid]').forEach(initGridReveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var story = e.target.querySelector('[data-story-section]');
    if (story) initHeroEntrance(story);
    var grid = e.target.querySelector('[data-motion-grid]');
    if (grid) initGridReveal(grid);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var story = e.target.querySelector('[data-story-section]');
    if (story) heroRegistry.delete(story);
    var grid = e.target.querySelector('[data-motion-grid]');
    if (grid) teardownGridReveal(grid);
  });
})();
